import { render } from "./ButtonModal.vue?vue&type=template&id=007ae371"
import script from "./ButtonModal.vue?vue&type=script&lang=js"
export * from "./ButtonModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__